import AxiosAPI from "./AxiosAPI";

// router.post("/setup/stores/", VerifyUser, CreateStore);
// router.put("/setup/stores/:storeID", VerifyUser, UpdateStore);
// router.delete("/setup/stores/:storeID", VerifyUser, DeleteStore);
// router.get("/setup/stores/", VerifyUser, GetStores);

export const fetchStore = async () => {
  try {
    const response = await AxiosAPI.get("/user/stores");
    return response.data;
  }
  catch (error) {
    throw error;
  }
};

export const checkIfStoreCodeIsUnique = async (params) => {
  try {
    const response = await AxiosAPI.get("/setup/stores/checkIfStoreCodeIsUnique", { params });
    return response.data;
  } catch (error) {
    throw error;
  }

};



export const fetchStores = async () => {
  try {
    const response = await AxiosAPI.get(`/setup/stores`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const handleAddStore = async (storeData) => {
  try {
    const response = await AxiosAPI.post("/setup/stores/", storeData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteStore = async (key) => {
  try {
    const response = await AxiosAPI.delete(
      `/setup/stores/${key}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const editPrintConfigDataApi = async (editStoreDataId, storeData) => {
  try {
    const response = await AxiosAPI.put(
      `/setup/stores/${editStoreDataId}`,
      storeData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const handleEditStore = async (data) => {
  try {
    const response = await AxiosAPI.put(
      `/setup/stores/${data.key}`,
      data, {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const fetchStoreAuditTrail = async (key) => {
  try {
    const response = await AxiosAPI.get(`/setup/stores/audittrail?key=${key}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const fetchSearchStores = async (
  from,
  size,
  option,
  searchText = '',
  searchCity = '',
  searchState = '',
  searchPostalCode = '',
  searchCountry = '',
  searchEmail='',
  searchPhone='',
  searchCustomField1 = '',
  searchCustomField2 = '',
  searchCustomField3 = '',
  searchCustomField4 = '',
  searchCustomField5 = '',
  searchCustomField6 = ''
) => {
  try {
    let apiUrl = `/setup/searchstores`;
    let queryParams = [];

    // Always include isDeleted parameter with false as default
    if (option) {
      queryParams.push(`option=${option}`);
    }

    if (from) {
      queryParams.push(`from=${from}`);
    }
    if (size) {
      queryParams.push(`size=${size}`);
    }
    if (searchEmail) {
      queryParams.push(`searchEmail=${(searchEmail)}`);
    }
    if (searchPhone) {
      queryParams.push(`searchPhone=${(searchPhone)}`);
    }
    if (searchText) {
      queryParams.push(`searchText=${(searchText)}`);
    }
    if (searchCity) {
      queryParams.push(`searchCity=${(searchCity)}`);
    }
    if (searchState) {
      queryParams.push(`searchState=${(searchState)}`);
    }
    if (searchPostalCode) {
      queryParams.push(`searchPostalCode=${(searchPostalCode)}`);
    }
    if (searchCountry) {
      queryParams.push(`searchCountry=${(searchCountry)}`);
    }
    if (searchCustomField1) {
      queryParams.push(`searchCustomField1=${(searchCustomField1)}`);
    }
    if (searchCustomField2) {
      queryParams.push(`searchCustomField2=${(searchCustomField2)}`);
    }
    if (searchCustomField3) {
      queryParams.push(`searchCustomField3=${(searchCustomField3)}`);
    }
    if (searchCustomField4) {
      queryParams.push(`searchCustomField4=${(searchCustomField4)}`);
    }
    if (searchCustomField5) {
      queryParams.push(`searchCustomField5=${(searchCustomField5)}`);
    }
    if (searchCustomField6) {
      queryParams.push(`searchCustomField6=${(searchCustomField6)}`);
    }

    apiUrl += queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    const response = await AxiosAPI.get(apiUrl);
    return response.data;
  } catch (err) {
    console.error('Error fetching stores:', err);
    throw err;
  }
};



